import { oldApi } from '../lib/api';

export class ShipsSearchApi {
  async getList(params, direction = 1) {
    return await oldApi.post(`/ApiShips/shipsList?direction=${direction}`, params);
  }
}
